import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard
import Dashboard from "../pages/Dashboard";

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
// import ForgotPassword from "../pages/Authentication/ForgotPassword";
import ForgotPassword from "../pages/Authentication/ForgotPassword/ForgotPassword";
import ForgotPasswordTwoVerify from "../pages/Authentication/ForgotPassword/TwoVerify";
import ResetPassword from "../pages/Authentication/ForgotPassword/ResetPassword";
import Register from "../pages/Authentication/Register";
import TwoVerify from "../pages/Authentication/TwoVerify";

// customer
import CustomerLogin from "../pages/Authentication/Customer/Login";
import CustomerTwoVerify from "../pages/Authentication/Customer/TwoVerify";
import CustomerRegister from "../pages/Authentication/Customer/Register";
import CustomerWelcome from "../pages/Authentication/Customer/Welcome";

// apps
import Companies from "../pages/Company";
import CompanyDetail from "../pages/Company/Detail";
import Customers from "../pages/Customer";
import Orders from "../pages/Order";
import Users from "../pages/User";
import BusinessPartners from "../pages/BusinessPartner";
import CustomerError from "../pages/Authentication/Customer/Error";
// import ProgressPayments from "../pages/ProgressPayment";

const authProtectedRoutes = [
  { path: "/", component: <Navigate to="/dashboard" /> },

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/company", component: <Companies /> },
  { path: "/company/detail", component: <CompanyDetail /> },
  { path: "/customer", component: <Customers /> },
  { path: "/orders", component: <Orders /> },
  { path: "/user", component: <Users /> },
  // { path: "/progress-payment", component: <ProgressPayments /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/register", component: <Register /> },
  { path: "/verify-otp", component: <TwoVerify /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  {
    path: "/forgot-password/verify-otp",
    component: <ForgotPasswordTwoVerify />,
  },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/customer/login", component: <CustomerLogin /> },
  { path: "/customer/verify-otp", component: <CustomerTwoVerify /> },
  { path: "/customer/register", component: <CustomerRegister /> },
  { path: "/customer/welcome", component: <CustomerWelcome /> },
  { path: "/customer/error", component: <CustomerError /> },

  { path: "/partners", component: <BusinessPartners /> },

  { path: "*", component: <Navigate to="/404" /> },

  // { path: "/auth-offline", component: <Offlinepage /> },
];

export { authProtectedRoutes, publicRoutes };
